// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Xa2h","title":"Header_title__n43Y8","left":"Header_left__1XiGF","clinicName":"Header_clinicName__3FZRI"};